import {
  CreateDownsellAPi,
  CreateDownsellDataParams,
} from "@/features/private-room/bookings/adapters/create-downsell";
import {
  SimulatedDownsellResponse,
  SimulateDownsellProps,
} from "@/features/private-room/bookings/context/use-downsell-flow/use-downsell-flow.types";
import { apiWobaBackend } from "@/services/api-woba-backend";
import { extractErrorMessage } from "@/utils/extract-error-message";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useDownsell = () => {
  const [simulatedDownsell, setSimulatedDownsell] =
    useState<SimulatedDownsellResponse | null>(null);
  const [downsellLoadingStatus, setDownsellLoadingStatus] = useState(false);
  const [downsellSuccess, setDownsellSuccess] = useState<boolean | null>(null);
  const [downsellErrorMessage, setDownsellErrorMessage] = useState<
    string | null
  >(null);

  const navigate = useNavigate();

  const handleBookingDownsellSimulation = async ({
    companyId,
    packageId,
    bookingId,
    cancelStrategy,
    poContractId,
    cancelledAt,
  }: SimulateDownsellProps) => {
    const { data } = await apiWobaBackend.post(
      `/companies/${companyId}/packages/${packageId}/simulate-downsell`,
      {
        bookingId,
        cancelStrategy,
        poContractId,
        cancelledAt,
      },
    );

    setSimulatedDownsell(data);
  };

  const handleCreateDownsell = async (data: CreateDownsellDataParams) => {
    setDownsellLoadingStatus(true);
    setDownsellErrorMessage(null);

    try {
      const response = await CreateDownsellAPi({
        data,
        navigate: navigate,
      });

      setDownsellSuccess(response.success);

      if (!response.success) {
        const errorMessage = extractErrorMessage(
          response.data,
          "Ocorreu um erro durante o processo de downsell.",
        );
        setDownsellErrorMessage(errorMessage);
      }
    } catch (error) {
      setDownsellSuccess(false);
      setDownsellErrorMessage(
        extractErrorMessage(
          error,
          "Ocorreu um erro durante o processo de downsell.",
        ),
      );
    } finally {
      setDownsellLoadingStatus(false);
    }
  };

  return {
    simulatedDownsell,
    handleBookingDownsellSimulation,
    handleCreateDownsell,
    downsellLoadingStatus,
    downsellSuccess,
    downsellErrorMessage,
  };
};
